// @flow
import PageEditorUtil from './PageEditorUtil';

/** The page as the server stores it: what a save sends (without the conflict timestamp). */
export const toPageInput = (d) => ({
  title: d.title,
  path: d.path,
  canonicalRel: d.canonicalRel,
  category: (d.category && d.category._id) || undefined,
  metadata: d.metadata,
  template: {
    templateId: d.template.templateId,
    version: d.template.version,
    props: d.template.props
  },
  // Ensure metadata isnt pushed
  slots: d.slots.map(s => ({
    slotId: s.slotId,
    components: s.components.map(co => ({
      presetId: co.presetId,
      widgetId: co.widgetId,
      props: co.props,
      subcomponents: (co.subcomponents && co.subcomponents.map(sub => PageEditorUtil.getSubcomponents(sub))) || []
    }))
  }))
});
